import noop from 'app/libs/noop';

const onAppLoaded = () => noop;

const onAppUnload = () => noop;

export { onAppLoaded, onAppUnload };
